import { MatchEvent } from "../matchEvent";
import { EventName } from "../enums/eventName";
import { OneMinuteTimerType } from "../enums/oneMinuteTimerType";

// REFSIX-819: the referee started a One Minute Timer (LOTG 2026/27) for a
// penalised delayed substitution or an injured player treated on the field.
// timestamp is when the minute started; the timer runs through stoppages,
// pauses while the match is suspended and stops at the end of the period, so
// how much of it is left is derived from the match events rather than stored.
export class OneMinuteTimerEvent extends MatchEvent {
    timerType: OneMinuteTimerType;

    constructor(
        timestamp: number,
        eventName: EventName,
        half: number,
        minuteOfPlay: number,
        timerType: OneMinuteTimerType
    ) {
        super(timestamp, eventName, half, minuteOfPlay);
        this.timerType = timerType;
    }

    static fromJSON(
        json: Pick<
            OneMinuteTimerEvent,
            "timestamp" | "eventName" | "half" | "minuteOfPlay" | "timerType"
        >
    ) {
        return new OneMinuteTimerEvent(
            json.timestamp,
            json.eventName,
            json.half,
            json.minuteOfPlay,
            json.timerType
        );
    }
}
